import { render, staticRenderFns } from "./TournamentProfileCard.vue?vue&type=template&id=6bc51607&scoped=true"
import script from "./TournamentProfileCard.vue?vue&type=script&lang=js"
export * from "./TournamentProfileCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentProfileCard.vue?vue&type=style&index=0&id=6bc51607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc51607",
  null
  
)

export default component.exports